import React from 'react';
import BaseCard from './BaseCard';
import VerticalBarChartTwo from '../../common/VerticalBarChartTwo';
import './TreatmentCard.scss';

const getBarColors = (count) => {
  // Use the same color logic as in the reference
  const palette = [
    '#282c87', // dark blue
    '#20c9e6', // cyan
    '#28c76f', // green
    '#a8aaae', // gray
    '#ff4c51', // red
    '#fbbf24', // yellow (if needed)
  ];
  return Array.from({ length: count }, (_, i) => palette[i % palette.length]);
};

const TreatmentCard = ({ graphData }) => {
  const defaultData = {
    categories: [],
    percentage: [],
    series: [
      {
        data: [],
      },
    ],
  };

  const chartData = graphData?.treatment || defaultData;
  const hasData = chartData.categories?.length > 0 && chartData.series?.[0]?.data?.some(value => value > 0);
  const colors = getBarColors(chartData.categories.length);

  return (
    <BaseCard 
      title="Treatment Breakdown"
      className="treatment-card"
    >
      <div className="treatment-card__content">
        {hasData ? (
          <div className="treatment-card__chart-legend-row">
            <div className="treatment-card__chart">
              <VerticalBarChartTwo graphData={chartData} colors={colors} />
            </div>
            <div className="treatment-card__legend">
              {chartData.categories.map((cat, idx) => (
                <div className="treatment-card__legend-item" key={cat}>
                  <span
                    className="treatment-card__legend-dot"
                    style={{ backgroundColor: colors[idx] }}
                  />
                  <div className="treatment-card__legend-labels">
                    <span className="treatment-card__legend-label">{cat}</span>
                    <span className="treatment-card__legend-value">{chartData.percentage[idx]}%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="treatment-card__no-data">No Data</div>
        )}
      </div>
    </BaseCard>
  );
};

export default React.memo(TreatmentCard); 